import { VideoCallsAppState, ClientState } from 'components/features/videoCalls/types/state'
import { Reducer } from 'interfaces'
import { AgoraJoinChannelAction, AgoraLeaveChannelAction, AgoraClientEventAction } from 'components/features/videoCalls/types/actions'

const INITIAL_STATE = new ClientState()
// const INITIAL_STATE: ClientState = {
//   ...new ClientState(),
//   state: 'active'
// }
export const clientReducer: Reducer<VideoCallsAppState['client']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case AgoraJoinChannelAction.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          state: 'progress',
        }
      }

      if (action.meta === 'fail') {
        return {
          ...prevState,
          state: 'idle',
        }
      }

      const { clientId } = action.payload.response
      return {
        ...prevState,
        state: 'active',
        clientId,
      }
    }

    case AgoraLeaveChannelAction.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          state: 'progress',
        }
      }

      if (action.meta === 'success') {
        return {
          ...prevState,
          state: 'idle',
        }
      }

      return prevState
    }

    case AgoraClientEventAction.type: {
      const event = action.payload
      switch (event.type) {
        case 'connection-state-change': {
          if (event.curState === 'CONNECTED') {
            return {
              ...prevState,
              state: 'active',
            }
          }

          return {
            ...prevState,
            state: 'progress',
          }
        }
      }
    }
  }
  return prevState
}
